import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { HistoryRouter } from "redux-first-history/rr6";
import { configureStore } from "redux/Store";
import App from 'app/App';
import './assets/css/main.scss'

const { store, history } = configureStore();
createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <HistoryRouter history={history}>
      <App />
    </HistoryRouter>
  </Provider>
);
